// Mock data for Retina Viva Institute

export const instituteMock = {
  name: "Instituto Integrado Paraibano da Saúde – Retina Viva",
  hero: {
    title: "Excelência em saúde ocular com foco em retina",
    subtitle: "Diagnóstico preciso, tecnologia avançada e atendimento especializado para preservar sua visão.",
    image: "https://images.unsplash.com/photo-1766310549795-dd0fc75d499f"
  },
  about: {
    text: "O Instituto Integrado Paraibano da Saúde – Retina Viva é uma instituição sem fins lucrativos sediada em João Pessoa, dedicada ao cuidado da saúde ocular, à educação em saúde e ao desenvolvimento humano. Atua por meio de atendimentos especializados, exames diagnósticos e ações sociais voltadas à melhoria da qualidade de vida da população.",
    image: "https://images.unsplash.com/photo-1769698678497-c41f0ab47c3e"
  },
  specializations: {
    title: "Especialização em Retina",
    description: "Nossa equipe é altamente especializada no diagnóstico e tratamento de doenças da retina, oferecendo cuidados abrangentes para preservar e restaurar sua visão.",
    items: [
      "Degeneração macular",
      "Retinopatia diabética",
      "Descolamento de retina",
      "Doenças do vítreo",
      "Cirurgias vitreorretinianas"
    ],
    image: "https://images.unsplash.com/photo-1705071393219-7c0c65afa314"
  },
  exams: {
    title: "Exames Oferecidos",
    items: [
      {
        name: "OCT",
        description: "Tomografia de Coerência Óptica",
        icon: "Microscope"
      },
      {
        name: "Retinografia Digital",
        description: "Imagens detalhadas da retina",
        icon: "Camera"
      },
      {
        name: "Angiografia Fluoresceínica",
        description: "Avaliação da circulação retiniana",
        icon: "Activity"
      },
      {
        name: "Mapeamento de Retina",
        description: "Exame completo do fundo de olho",
        icon: "Map"
      },
      {
        name: "Ultrassom Ocular",
        description: "Diagnóstico por imagem",
        icon: "Radio"
      }
    ],
    image: "https://images.unsplash.com/photo-1722419136179-991a684eee53"
  },
  structure: {
    title: "Estrutura e Tecnologia",
    description: "Nossa clínica oferece um ambiente moderno e acolhedor, equipado com tecnologia de ponta para diagnósticos precisos e tratamentos eficazes.",
    features: [
      "Consultórios modernos e confortáveis",
      "Equipamentos de alta tecnologia",
      "Ambiente climatizado e acessível",
      "Diagnóstico preciso e rápido"
    ],
    image: "https://images.unsplash.com/photo-1606206873764-fd15e242df52"
  },
  insurance: {
    title: "Convênios",
    description: "Atendimento particular e por convênios médicos. Consulte a cobertura disponível."
  },
  contact: {
    phone: "(83) 8826-6983",
    whatsapp: "(83) 8826-6983",
    email: "institutoretinaviva@gmail.com",
    address: {
      street: "Praça da Independência, 18, Sala 104",
      district: "Centro",
      city: "João Pessoa",
      state: "PB",
      zipCode: "58013-025"
    },
    hours: "Segunda a sexta, 8h às 18h",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3958.5877893765944!2d-34.8797!3d-7.1195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7ace839165e0001%3A0x4c48b6c1f7891e9a!2sPra%C3%A7a%20da%20Independ%C3%AAncia%2C%2018%20-%20Centro%2C%20Jo%C3%A3o%20Pessoa%20-%20PB%2C%2058013-025!5e0!3m2!1spt-BR!2sbr!4v1234567890!5m2!1spt-BR!2sbr"
  },
  footer: {
    legalText: "O Instituto Integrado Paraibano da Saúde – Retina Viva é uma instituição privada sem fins lucrativos voltada à promoção da saúde, educação e desenvolvimento humano. Suas atividades seguem os princípios da legalidade, impessoalidade, moralidade, publicidade, economicidade e eficiência, sem qualquer forma de discriminação."
  },
  contactFormSubjects: [
    "Agendamento de consulta",
    "Informações sobre exames",
    "Convênios médicos",
    "Dúvidas gerais",
    "Outro"
  ]
};
